export default "__VITE_ASSET__BxaHpQsg__"